import gql from 'graphql-tag';

// Create a group
export const MUTATION_CREATE_GROUP = gql`
  mutation add_group($name: String!) {
    insert_groups(objects: { name: $name }) {
      returning {
        id
        name
      }
    }
  }
`;

// Delete all groups
export const MUTATION_DELETE_ALL_GROUPS = gql`
  mutation delete_all_groups {
    delete_groups(where: {}) {
      returning {
        id
      }
    }
  }
`;

// Delete a group
export const MUTATION_DELETE_GROUP = gql`
  mutation delete_group($groupId: Int!) {
    delete_groups(where: { id: { _eq: $groupId } }) {
      returning {
        id
      }
    }
  }
`;

// Rename existing group
export const MUTATION_RENAME_GROUP = gql`
  mutation rename_group($groupId: Int!, $name: String!) {
    update_groups(where: { id: { _eq: $groupId } }, _set: { name: $name }) {
      returning {
        id
        name
      }
    }
  }
`;

// Add user to the group
export const MUTATION_ADD_USER_TO_GROUP = gql`
  mutation add_user_group($groupId: Int!, $userId: Int!) {
    insert_user_groups(objects: { group_id: $groupId, user_id: $userId }) {
      returning {
        group_id
        user_id
      }
    }
  }
`;

// Delete all users from all of the groups
export const MUTATION_DELETE_ALL_USERS_FROM_ALL_GROUPS = gql`
  mutation delete_all_users_from_all_groups {
    delete_user_groups(where: {}) {
      returning {
        group_id
        id
        user_id
      }
    }
  }
`;

// Delete user from the group
export const MUTATION_DELETE_ALL_USERS_FROM_GROUP = gql`
  mutation delete_all_users_from_group($groupId: Int!) {
    delete_user_groups(where: { group_id: { _eq: $groupId } }) {
      returning {
        group_id
        id
        user_id
      }
    }
  }
`;

// Delete user from the group
export const MUTATION_DELETE_USER_FROM_GROUP = gql`
  mutation delete_user_from_group($groupId: Int!, $userId: Int!) {
    delete_user_groups(where: { group_id: { _eq: $groupId }, user_id: { _eq: $userId } }) {
      returning {
        group_id
        user_id
      }
    }
  }
`;

// Get all groups
export const QUERY_GET_ALL_GROUPS = gql`
  query groups {
    groups(where: {}) {
      id
      name
    }
  }
`;

// Get all group members
export const QUERY_GET_ALL_MEMBERS = gql`
  query get_all_members {
    user_groups(where: {}) {
      group_id
      user_id
    }
  }
`;

// Get all members of a sepcific group
export const QUERY_GET_GROUP_MEMBERS = gql`
  query get_members($groupId: Int!) {
    user_groups(where: { group_id: { _eq: $groupId } }) {
      id
      name
    }
  }
`;

// Get a sepcific group member (used to check if a member was already invited)
export const QUERY_GET_GROUP_MEMBER = gql`
  query get_member($groupId: Int!, $userId: Int!) {
    user_groups(where: { group_id: { _eq: $groupId }, user_id: { _eq: $userId } }) {
      id
    }
  }
`;
